<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <div class="row">
          <div class="col-md-6">
            <h3 class="text-bold">{{ ezy.date(data.created_at) }}</h3>
          </div>
          <div class="col-md-6 text-right">
            <button class="btn btn-xs btn-success" @click="$router.back()">
              Back
            </button>
          </div>
        </div>
      </div>
      <div class="grid-body">
        <table class="table">
          <tbody>
            <tr>
              <th>Tracking Number</th>
              <th>Shipper</th>
              <th>Air Line</th>
              <th>Flight Number</th>
            </tr>
            <tr>
              <td>
                <small v-if="error.awb" class="text-danger">* Required</small>
                <input type="text" v-model="data.awb" class="form-control" />
              </td>
              <td>
                <small v-if="error.shipper" class="text-danger"
                  >* Required</small
                >
                <input
                  type="text"
                  v-model="data.shipper"
                  class="form-control"
                />
              </td>
              <td>
                <small v-if="error.airline" class="text-danger"
                  >* Required</small
                >
                <input
                  type="text"
                  v-model="data.airline"
                  class="form-control"
                />
              </td>
              <td>
                <small v-if="error.flight_no" class="text-danger"
                  >* Required</small
                >
                <input
                  type="text"
                  v-model="data.flight_no"
                  class="form-control"
                />
              </td>
            </tr>
            <tr>
              <th>Estimate Time of Arrival</th>
              <th colspan="3"></th>
            </tr>
            <tr>
              <td>
                <small v-if="error.eta" class="text-danger">* Required</small>
                <datepicker
                  :clear-button="true"
                  placeholder="Select Date"
                  v-model="data.eta"
                  input-class="form-control"
                >
                </datepicker>
              </td>
              <td colspan="3"></td>
            </tr>
            <tr>
              <th colspan="2">Internal Info</th>
              <th colspan="2">Fiber Percentage</th>
            </tr>
            <tr>
              <td colspan="2" class="v-aligin-top">
                <textarea
                  class="form-control"
                  v-model="data.internal_infos"
                  rows="5"
                ></textarea>

                <!-- Summary Information -->
                <p class="subsection-heading mt-10">General Information</p>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Number of Boxes</th>
                    </tr>
                    <tr>
                      <td>{{ data.kartons }}</td>
                    </tr>
                  </tbody>
                </table>

                <p class="subsection-heading mt-10">Product Information</p>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Product Name</th>
                      <th>Quantity</th>
                    </tr>
                    <tr
                      v-for="(total, key) in data.product_information"
                      :key="key"
                    >
                      <td>{{ key }}</td>
                      <td>{{ total }}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- Summary Information -->
              </td>
              <td colspan="2" class="text-left">
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Carton No.</th>
                      <th class="text-right">Cotton</th>
                      <th class="text-right">Polyester</th>
                      <th class="text-right">Spandex</th>
                      <th class="text-right">Other</th>
                    </tr>
                    <tr
                      v-for="(fiber, index) in data.fiber_percentage"
                      :key="index"
                    >
                      <td>{{ index }}</td>
                      <td class="text-right">{{ fiber.Cotton }} %</td>
                      <td class="text-right">{{ fiber.Polyester }} %</td>
                      <td class="text-right">{{ fiber.Spandex }} %</td>
                      <td class="text-right">{{ fiber.Other }} %</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <button
                  class="btn btn-primary btn-block"
                  @click="updateShipment()"
                  v-if="!isReadOnlyUser"
                >
                  Update
                </button>
              </td>
              <td colspan="2">
                <button
                  v-if="data.latest_shipment && !data.shipment_completed"
                  class="btn btn-success btn-block"
                  @click="creatShipmentInGermany()"
                >
                  Create Shipment in Germany
                </button>
                <div
                  class="alert alert-success mt-20"
                  role="alert"
                  v-if="data.shipment_completed"
                >
                  <strong>Shipment Created in Germany</strong>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <hr />
        <h3>Carton Listings</h3>

        <button
          class="btn btn-success float-right mb-5"
          @click="printShipment()"
        >
          Print
        </button>

        <ShipmentCartonDetail :cartons="cartons" />
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import ShipmentCartonDetail from "./components/ShipmentCartonDetail";

export default {
  components: {
    Datepicker,
    ShipmentCartonDetail,
  },
  data() {
    return {
      isReadOnlyUser: false,
      data: {},
      cartons: [],
      error: {},
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getShipmentDetail();
  },
  methods: {
    async getShipmentDetail() {
      try {
        let res = await axios.get(
          "packaging/shipment/detail/" + this.$route.params.id
        );
        let data = res.data;
        data["fiber_percentage"] = data["fiber_percentage"];
        this.data = data;
        let details = res.data.shipment_details;

        let cartons = [];
        details.forEach((val) => {
          if (!cartons[val.karton]) {
            cartons[val.karton] = {
              no: val.karton,
              components: val.type === "other",
              total: val.type === "other" ? 0 : val.total,
              fields: [val],
            };
          } else {
            if (val.type === "other") {
              cartons[val.karton].components = true;
            }
            (cartons[val.karton].total += val.type === "other" ? 0 : val.total),
              cartons[val.karton].fields.push(val);
          }
        });

        cartons.forEach((val) => {
          this.cartons.push(val);
        });
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    validate() {
      return new Promise((resolve) => {
        this.error = {};
        if (!this.data.awb) {
          this.error["awb"] = true;
        }
        if (!this.data.airline) {
          this.error["airline"] = true;
        }
        if (!this.data.flight_no) {
          this.error["flight_no"] = true;
        }
        if (!this.data.eta) {
          this.error["eta"] = true;
        }
        if (!this.data.shipper) {
          this.error["shipper"] = true;
        }
        if (ezy.objectLength(this.error) > 0) {
          toastr.error("Please fill required inputs!");
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },

    updateShipment(showAlert = true) {
      return new Promise(async (resolve) => {
        let data = this.data;
        let params = {
          awb: data.awb,
          shipper: data.shipper,
          airline: data.airline,
          flight_no: data.flight_no,
          eta: moment(data.eta).format("YYYY-MM-DD"),
          german_delivery_print_time: moment(
            data.german_delivery_print_time
          ).format("YYYY-MM-DD"),
          internal_infos: data.internal_infos,
          dpd_done: moment(data.dpd_done).format("YYYY-MM-DD"),
        };

        try {
          let res = await axios.put(
            "packaging/shipment/update/" + this.$route.params.id,
            params
          );
          if (res) {
            if (showAlert) {
              toastr.success("SUCCESS");
            }
            resolve(true);
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      });
    },

    async creatShipmentInGermany() {
      if (await this.validate()) {
        if (await ezy.confirm("Are you sure?", "YES")) {
          if (await this.updateShipment(false)) {
            try {
              let res = await axios({
                url:
                  "packaging/shipment/create/consultant_system/" +
                  this.$route.params.id,
                method: "POST",
              });
              if (res) {
                toastr.success("Success");
                this.data.shipment_completed = true;
              }
            } catch (error) {
              if (error.response.status === 403) {
                toastr.error(
                  "Not authorized, please ensure that you have the required permissions."
                );
              } else {
                let errorMessage = error.response.data.message;
                toastr.error(errorMessage);
              }
            }
          }
        }
      }
    },

    async printShipment() {
      if (await ezy.confirm("Are you sure?", "YES")) {
        try {
          let res = await axios({
            url: "packaging/shipment/print/" + this.$route.params.id,
            method: "GET",
            responseType: "blob", // important
          });
          if (res) {
            var url = URL.createObjectURL(res.data);
            window.open(url, "_blank");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.table td {
  border-top: none !important;
}
.v-aligin-top {
  vertical-align: top !important;
}

.subsection-heading {
  font-weight: bold;
}
.mt-10 {
  margin-top: 10px;
}
</style>
